import {XANADU} from '../transactions/contracts.js';
import XanaduContract from '../contracts/XanaduContract.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import EthereumQuery from 'decentralized/EthereumQuery.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import EthereumTransaction from '../transactions/EthereumTransaction.js';
import {SEQUENCE_BPM} from './LinkTypes.js';
import {
    NewAnnotationType,
    NewAnnotation,
    NewLinkType,
    NewLink,
    NewDataType
} from 'decentralized/EthereumEvents.js';

export default superclass => class extends superclass  {
    async syncProjectBPM(hash, bpm) {
        console.log("syncProjectBPM(%s, %s", hash, bpm);
        await new EthereumTransaction(
            XANADU,
            'newAnnotation',
            [
                this.web3.utils.fromAscii(SEQUENCE_BPM),
                ipfsHashToBytes32(hash),
                this.web3.utils.fromAscii(bpm.toString())])
            .execute();
    }

    async getProjectsWithBPM(hashes, bpm, user) {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewAnnotation)
            .select('data')
            .select('annotationData')
            .where('annotationType', SEQUENCE_BPM)
            .whereIn('data', hashes);
        if (user) {
            query.where("address", user.toLowerCase());
        }

        let results = await query.executeQuery();
        let idToRating = {};
        for (let result of results) {
            let id = result.data;
            let rating = parseInt(result.annotationData);
            if (idToRating[id] === undefined && rating===bpm) {
                idToRating[id] = rating;
            }
        }
        return Object.keys(idToRating);
    }

    async getProjectBPM(hash, user) {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewAnnotation)
            .select('data')
            .select('annotationData')
            .where('data', hash)
            .where('annotationType', SEQUENCE_BPM);

        if (user) {
            query.where("address", user.toLowerCase());
        }

        let results = await query.executeQuery();
        if (results.length === 0) {
            return undefined;
        }
        return parseInt(results[0].annotationData);
    }
}
